export const Data = {
  profile: {
    name: "Atrid Ahmetaj",
    ocupation: "FullStack Software Developer",
    location: "Tirane, Albania",
    email: "atrid1995@gmail.com",
    telephone: "+355 693848139",
    image: "images/photo.jpg",
  },
  aboutMe: {
    label: "About me",
    description:
      "Full stack developer with 4 years of experience in designing, developing, testing, implementing and maintaining software. Excellent knowledge on a variety of platforms, languages, and software systems.",
  },
  skills: {
    technicalLabel: "Technologies",
    softLabel: "Skills",
    technicalSkills: [
      "Java, Spring Boot, Android Java, Angular, React, Polymerjs, Bash",
      "Spring Data JPA, Hibernate, Entity Framework",
      "JUnit testing, Integration testing, Mockito",
      "Oracle 19c, MySQL, MariaDB, SQL Server, Time series, Postgres",
      "Flutter",
      "IntelliJ Idea, Eclipse, Visual Studio",
      "Scrum, Confluence, Jira, Bitbucket, Docusaurus",
      "Microservices, Event-Driven Architecture, Monolithic, REST, SOAP, Docker, k8s",
      "Open API, Swagger, RestDocs",
    ],
    softSkills: [
      "Analysis",
      "Problem solving",
      "Critical thinking",
      "Teamwork",
      "Communication",
      "Proactivity",
      "Creativity",
      "Autodidact",
      "Mentoring",
    ],
  },
  socialMedia: {
    label: "SOCIAL",
    social: [
      {
        label: "Atrid Ahmetaj",
        name: "linkedin",
        url: "https://www.linkedin.com/in/atrid-ahmetaj-6a3775108/",
        className: "bxl-linkedin-square",
      },
      {
        label: "atridahmetaj",
        name: "github",
        url: "https://github.com/atridahmetaj",
        className: "bxl-github",
      },
    ],
  },
  experience: {
    works: [
      {
        title: "DEVOPS ENGINEER",
        period: "Nov. 2021 – Present",
        company: "OAZ",
        description: [
          "Oaz Express, has been released on the AppStore and PlayStore (only visible in Albania) and coordinates businesses with postal company.",
          "Primary responsibilities include communication with clients and users, performing business analysis, cooperating with my partner to share ideas, implementing and delivering the application."
        ],
      },
      {
        title: "FULL-STACK DEVELOPER",
        period: "Aug. 2020 - Present",
        company: "Keendoo",
        description: [
          "Leading a team of 4 developers while working on Keendoo's main project, which is developed using Java EE and Polymer.",
          "Worked with a monolithic architecture for the main project.",
          "Developed several side projects using the Java Spring Boot framework on the backend, with both monolithic and microservice architectures.",
          "Utilized Angular or React for the frontend of these side projects, depending on the specific requirements.",
          "Gained extensive experience working with a variety of technologies and architectures.",
          "Delivered high-quality solutions to complex problems."
        ],
      },
      {
        title: "BACKEND DEVELOPER",
        period: "Mar. 2019 – Aug. 2020",
        company: "Linfa",
        description: [
          "Developed skills as a Java EE developer over a 17-month period.",
          "Utilized Spring Boot extensively and gained experience with important concepts such as Spring Security, state machine, interceptors, Hibernate, and JPA.",
          "Worked with both monolithic and microservices architecture in various projects.",
          "Contributed to several projects at Linfa.",
          "Focused on projects within the e-banking industry."
        ],
      },
      {
        title: "SOFTWARE DEVELOPER",
        period: "Nov. 2018 – Mar. 2019",
        company: "SoftExpress",
        description: [
          "Developed software using Visual Basic 6 for a company that specialized in business management applications for industries such as coffee shops, restaurants, and hotels.",
          "Developed an application that communicated with several third-party systems, such as the fiscal system or spiderweb booking API.",
          "Implemented a wide range of financial features, including revenue calculation and report generation using JasperReports."
        ],
      },
    ],
    academic: [
      {
        career: "Bachelor degree",
        date: "2014 – 2017",
        institution: "University of Tirana",
      },
      {
        career: "Master degree",
        date: "2017 – 2018",
        institution: "University of Tirana",
      },
      {
        career: "Training",
        date: "Aug. 2018 – Nov. 2018",
        institution: "IkubInfo",
      },
    ],
  },
};
